import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.496 7.247c0-3.375 1.688-6.75 6.75-6.75s6.75 3.375 6.75 6.75c0 1.6-.379 3.2-1.318 4.441L15.5 14.51l-.99.99-2.816-2.816c-1.045.81-2.495 1.313-4.448 1.313-5.062 0-6.75-3.375-6.75-6.75"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MagnifierFilledSize16Glyph.displayName = 'MagnifierFilledSize16Glyph';
